export const LARGE_SPINNER_SIZE = 64;
export const SMALL_SPINNER_SIZE = 32;